module.exports = __webpack_public_path__ + "static/media/morning-tranquility.a15ad6f6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Landscape/morning-tranquility.jpg
// module id = 306
// module chunks = 0